import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Assessor.css";
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';
import withMenuPermission from "../../../widgets/withMenuPermission";
import EnhancedTable from '../../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../../widgets/Toolbar';


const utils = new ViewUtils();

const lowertoolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to assessor qualification scope', theme: true },
                { id: 'next', label: 'NEXT', tooltip: 'Proceed to skills programme scope', theme: true }
            ]
        }
    ]
};

const headCells = [
    { id: 'SAQAUnitStandardID', numeric: false, disablePadding: true, label: 'Unitstandard Code' },
    { id: 'SAQAUnitStandardTitle', numeric: false, disablePadding: true, label: 'Unitstandard Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'UnitStandardRegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'UnitStandardRegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' }
];

class OnlineAssessorApprovalUnitstandardScope extends Component {

    constructor(props) {
        super(props)

        this.state = {
            searchParameters: [{ Name: `OnlineAssessorAppID`, Value: this.props.location.state.selection }],
            USScope: null
        }
    }

    handleLowerToolbarButtonClick(buttonId) {
        if ("next" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineAssessorApprovalSkillsProgrammeScope',
                state: {
                    selection: this.props.location.state.selection,
                    QualScopeSelection: this.props.location.state.QualScopeSelection,
                    USScopeSelection: this.state.USScope
                }
            });
        } else if ("back" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineAssessorApprovalQualificationScope',
                state: {
                    selection: this.props.location.state.selection
                }
            });
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ USScope: selection })
        }
        else {
            this.setState({ USScope: null })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Assessor Approval > Standalone Unit Standards Scope"}
                </p>
                <br></br>
                <EnhancedTable multiSelect={true} autoFetchData={true} headCells={headCells} searchParameters={this.state.searchParameters} paged={false}
                    dataUrl="api/sims/OnlineAssessorApproval/GetUnitstandardScope" onSelectionChange={this.handleSelectionChange}
                />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%">
                            </td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleLowerToolbarButtonClick(buttonId)} config={lowertoolbarConfig} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(OnlineAssessorApprovalUnitstandardScope));

